import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { merge, throwError as _throw } from 'rxjs';
import { switchMap, filter } from 'rxjs/operators';

import { DlgTipsComponent } from '../core/dlg-tips.component';

@Injectable()
export class ShowDlgWorldTipsService {
    constructor(
        private _dialog: MatDialog,
    ) {
    }

    show(): Promise<any> {
        const dialogRef = this._dialog.open(DlgTipsComponent, {
            backdropClass: '--ui-backdrop',
            panelClass: ['--ui', '--transparent']
        });

        const source = dialogRef.afterClosed();
        const success$ = source
            .pipe(filter<boolean>((val) => !val))
            .pipe(switchMap((error) => _throw(`${ error }`)));
        const back$ = source
            .pipe(filter((val) => !!val));

        return merge(success$, back$).toPromise();
    }
}
